import APP_ROUTES from './app-routes';

//

const APP_BASE_PATHS = {
  default: '/learning-lab',
  chromeless: '/learning-lab/x',
  uxp: '/learning-lab/uxp',
};

const APP_EXTERNAL_BASE_PATHS = {
  uxp: '/my-learning',
};

const APP_PATHS = {
  addActivityLab: APP_ROUTES.addActivityLab,
  addAssessment: APP_ROUTES.addAssessment,
  addSubject: '/subjects/add',
  activityLabs: APP_ROUTES.activityLabs,
  createAccount: APP_ROUTES.createAccount,
  createProfile: APP_ROUTES.createProfile,
  home: APP_ROUTES.home,
  login: APP_ROUTES.login,
  onDemand: APP_ROUTES.onDemand,
  oops: APP_ROUTES.oops,
  orchestrator: APP_ROUTES.orchestrator,
  selectProfile: APP_ROUTES.selectProfile,
  sessionRecaps: '/session-recaps',
  standardsResults: APP_ROUTES.standardsResults,
  studentAgenda: APP_ROUTES.studentAgenda,
  tutorChat: APP_ROUTES.tutorChat,
  studySupportEssays: APP_ROUTES.essays,
  unsupportedRole: APP_ROUTES.unsupportedRole,
};

// Exports
// -------

export { APP_BASE_PATHS, APP_EXTERNAL_BASE_PATHS, APP_PATHS };

export default APP_PATHS;
